import { Component, OnInit,ViewChild,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {MatSnackBar} from '@angular/material';
import { Http, Response,Headers } from '@angular/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs/Subject';
import { NgForm } from '@angular/forms';
import {CookieService} from 'angular2-cookie/core';
import {SnackbarComponent} from '../snackbar/snackbar.component';

class Data {
  id: number=0;
  question: string='';
  a: string='';
  b: string='';
  c: string='';
  d: string='';
  answer: string='';
  description: string='';
}



@Component({
  selector: 'app-chaptertest',
  templateUrl: './chaptertest.component.html',
  styleUrls: ['./chaptertest.component.css'],
  providers: [HelperService] 
})
export class ChaptertestComponent implements OnInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
  chapter_id=0;
  dtOptions: DataTables.Settings = {};
  dtElement: DataTableDirective;
  datas:any=[];
  dtTrigger: Subject<any> = new Subject();

  list=true;
  edit=false;
  add=false;

  icon=this.helper.add_icon;
  icon_action='addClick';

  id: number=0;
  question: string='';
  a: string='';
  b: string='';
  c: string='';
  d: string='';
  answer: any=[];
  description: string='';
  options:any=[];
  syllabus_id;
  gradeid;
  subjectid;
  subjectgradeid;
  syllabusname;
  gradename;
  subjectname;
  chaptername;
  sub;
  questionoption1:any=[];
  questionoption2:any=[];
  questionoption3:any=[];
  questionoption4:any=[];
  questiondescription:any=[];

  user_permissions:any=[];
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
@ViewChild("questionImage") questionImage;
@ViewChild("answeraImage") answeraImage;
@ViewChild("answerbImage") answerbImage;
@ViewChild("answercImage") answercImage;
@ViewChild("answerdImage") answerdImage;
@ViewChild("descriptionImage") descriptionImage;
@ViewChild("addquestionImage") addquestionImage;
@ViewChild("addansweraImage") addansweraImage;
@ViewChild("addanswerbImage") addanswerbImage;
@ViewChild("addanswercImage") addanswercImage;
@ViewChild("addanswerdImage") addanswerdImage;
@ViewChild("adddescriptionImage") adddescriptionImage;
viewquestionImage;
viewdescriptionImage;
viewoptionAImage;
viewoptionCImage;
viewoptionDImage;
viewoptionBImage;

chaptertestbtndisbled = false;
  constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private activatedRouter:ActivatedRoute,private router:Router,private cookie:CookieService) {
    this.activatedRouter.params.subscribe((params: Params) => {
      this.chapter_id = params['id'];
      this.syllabus_id = params['syllabusid'];
      this.gradeid = params['gradeid'];
      this.subjectid = params['subject_id'];
      this.subjectgradeid = params['subjectgradeid'];
      this.sub            =  params['sub'];
    });
  }
  ngOnInit() {
    let user=this.cookie.get('user_id');
this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })

.subscribe(data => {
  this.user_permissions = JSON.parse(data['_body']);
 //console.log(this.user_permissions);
    
 
});
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
    
    this.http.get(this.helper.base_url+'http/get/chaptertest/'+this.chapter_id,{ headers: this.headers })
     
      .subscribe(res => {
      
        this.datas = JSON.parse(res['_body']).data;
        this.options= JSON.parse(res['_body']).options;
       
        this.dtTrigger.next();
        
       
      });
      this.http.get(this.helper.base_url+'http/get/syllabus/'+this.syllabus_id,{ headers: this.headers })
      .subscribe(
         
        (data) => {
          let body = JSON.parse(data['_body']);
          //console.log(body);
          this.syllabusname = body.data[0].name;
          //console.log(this.syllabusname);
          //alert(this.syllabusname);
          // this.refresh();
        }, //For Success Response
        err => {console.error(err)} //For Error Response
    );
    this.http.get(this.helper.base_url+'http/get/gradedetails/'+this.gradeid,{ headers: this.headers })
    .subscribe(
       
      (data) => {
        let body = JSON.parse(data['_body']);
        //console.log(body);
        this.gradename = body.data[0].name;
        //console.log(this.gradename);
        //alert(this.syllabusname);
        // this.refresh();
      }, //For Success Response
      err => {console.error(err)} //For Error Response
  );
  this.http.get(this.helper.base_url+'http/get/subjectsdetails/'+this.subjectid,{ headers: this.headers })
    .subscribe(
       
      (data) => {
        let body = JSON.parse(data['_body']);
        //console.log(body);
        this.subjectname = body.data[0].name;
        //console.log(this.gradename);
        //alert(this.syllabusname);
        // this.refresh();
      }, //For Success Response
      err => {console.error(err)} //For Error Response
  );
  this.http.get(this.helper.base_url+'http/get/chapter/'+this.chapter_id,{ headers: this.headers })
  .subscribe(
     
    (data) => {
      let body = JSON.parse(data['_body']);
      //console.log(body);
      this.chaptername = body.data[0].name;
      //console.log(this.chaptername);
      //alert(this.syllabusname);
      // this.refresh();
    }, //For Success Response
    err => {console.error(err)} //For Error Response
);


  }
  editClick(data){
   
   this.id=data.id;
   if(data.question=="null")
   {
    this.question="";
   }
   else
   {
    this.question=data.question;
   }
   if(data.a=="null")
   {
    this.a="";
   }
   else
   {
    this.a=data.a;
   }
   if(data.b=="null")
   {
    this.b="";
   }
   else
   {
    this.b=data.b;
   }
   if(data.c=="null")
   {
    this.c="";
   }
   else
   {
    this.c=data.c;
   }
   if(data.d=="null")
   {
    this.d="";
   }
   else
   {
    this.d=data.d;
   }
  //  this.a=data.a;
  //  this.b=data.b;
  //  this.c=data.c;
  //  this.d=data.d;
   this.answer=[data.answer];
   //console.log(this.answer);
   this.description=data.description;
   if(data.questionImage)
   this.viewquestionImage = this.helper.aws_url+data.questionImage;
   else
   this.viewquestionImage ="";
   if(data.optionAImage)
   this.viewoptionAImage = this.helper.aws_url+data.optionAImage;
   else
   this.viewoptionAImage ="";
   if(data.optionBImage)
   this.viewoptionBImage = this.helper.aws_url+data.optionBImage;
   else
   this.viewoptionBImage ="";
   if(data.optionCImage)
   this.viewoptionCImage = this.helper.aws_url+data.optionCImage;
   else
   this.viewoptionCImage ="";
   if(data.optionDImage)
   this.viewoptionDImage = this.helper.aws_url+data.optionDImage;
   else
   this.viewoptionDImage ="";
   if(data.descriptionImage)
   this.viewdescriptionImage = this.helper.aws_url+data.descriptionImage;
   else
   this.viewdescriptionImage ="";
   
   this.list=false;
   this.edit=true;
   this.add=false;
   this.icon=this.helper.list_icon;
   this.icon_action="listClick";
   //console.log(this.answer);
  }
  listClick(e){
    this.list=true;
    this.edit=false;
    this.add=false;
    this.icon=this.helper.add_icon;
    this.icon_action="addClick";
  }
  addClick(e){
  
    this.list=false;
    this.edit=false;
    this.add=true;
    this.icon=this.helper.list_icon;
    
    this.icon_action="listClick";
  }
  add_form(addForm: NgForm){
    this.chaptertestbtndisbled = true;
    let addfi = this.addquestionImage.nativeElement;
    let addansweraImage = this.addansweraImage.nativeElement;
    let addanswerbImage = this.addanswerbImage.nativeElement;
    let addanswercImage = this.addanswercImage.nativeElement;
    let addanswerdImage = this.addanswerdImage.nativeElement;
    let adddescriptionImage = this.adddescriptionImage.nativeElement;
    let body = new FormData();
    body.append('question', addForm.value.question);
    body.append('questionImage', addfi.files[0]);
    body.append('a', addForm.value.a);
    body.append('answeraImage', addansweraImage.files[0]);
    body.append('b', addForm.value.b);
    body.append('answerbImage', addanswerbImage.files[0]);
    body.append('c', addForm.value.c);
    body.append('answercImage', addanswercImage.files[0]);
    body.append('d', addForm.value.d);
    body.append('answerdImage', addanswerdImage.files[0]);
    body.append('answer', addForm.value.answer);
    body.append('description', addForm.value.description);
    body.append('descriptionImage', adddescriptionImage.files[0]);
  
 
     this.http.post(this.helper.base_url+'http/add/chaptertest/'+this.chapter_id, body,{ headers: this.headers })
     .subscribe(
       (res) => {
       this.listClick(null) ;
       this.refresh(false,'Test added successfully') ;
       }, //For Success Response
        err => {this.chaptertestbtndisbled = false;console.error(err)} //For Error Response);
     );
   }
   update_form(updateForm: NgForm){
    this.chaptertestbtndisbled = true;
    let fi = this.questionImage.nativeElement;
    let answeraImage = this.answeraImage.nativeElement;
    let answerbImage = this.answerbImage.nativeElement;
    let answercImage = this.answercImage.nativeElement;
    let answerdImage = this.answerdImage.nativeElement;
    let descriptionImage = this.descriptionImage.nativeElement;
    if(updateForm.value.a == null)
    {
      updateForm.value.a = "";
    }
    if(updateForm.value.b == null)
    {
      updateForm.value.b = "";
    }
    if(updateForm.value.question == null)
    {
      updateForm.value.question = "";
    }
    if(updateForm.value.c == null)
    {
      updateForm.value.c = "";
    }
    if(updateForm.value.d == null)
    {
      updateForm.value.d = "";
    }
    if(updateForm.value.description == null)
    {
      updateForm.value.description = "";
    }
    let body = new FormData();
    body.append('question', updateForm.value.question);
    body.append('questionImage', fi.files[0]);
    body.append('a', updateForm.value.a);
    body.append('answeraImage', answeraImage.files[0]);
    body.append('b', updateForm.value.b);
    body.append('answerbImage', answerbImage.files[0]);
    body.append('c', updateForm.value.c);
    body.append('answercImage', answercImage.files[0]);
    body.append('d', updateForm.value.d);
    body.append('answerdImage', answerdImage.files[0]);
    body.append('answer', updateForm.value.answer);
    body.append('description', updateForm.value.description);
    body.append('descriptionImage', descriptionImage.files[0]);

     this.http.post(this.helper.base_url+'http/update/chaptertest/'+this.id, body,{ headers: this.headers })
     .subscribe(
       (res) => {
        this.listClick(null) ;
        this.refresh(false,'Test updated successfully') ;
       }, //For Success Response
        err => {this.chaptertestbtndisbled = false;console.error(err)} //For Error Response);
     );
   }
   deleteClick(id){
    let snackBarRef = this.snackbar.openFromComponent(SnackbarComponent, {
      duration: 3000,
      extraClasses:  ['warning-snackbar'],
    });
    snackBarRef.onAction().subscribe(() => {
    this.http.get(this.helper.base_url+'http/delete/chaptertest/'+id,{ headers: this.headers })
      .subscribe(
         
          (data) => this.refresh(false,'Test Removed successfully'), //For Success Response
          err => {console.error(err)} //For Error Response
      ); 
    });  
  }
  backbtn(){
    window.history.back();
  }
  private extractData(res: Response) {
    const body = res.json();
    return body.data || {};
  }

  refresh(val=false,msg=''){
   
    this.snackbar.open(msg, null, {
      duration:5000,
        extraClasses:'success-snackbar',
        verticalPosition:'top'
      });
    this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
    this.router.navigate(["chaptertest/"+this.chapter_id,this.syllabus_id,this.subjectgradeid,this.subjectid,this.gradeid,this.sub]));
        
   }
   viewOutput(question,questionoption1,questionoption2,questionoption3,questionoption4,questiondescription)
   {
     //alert(question);
    // var question1 = "sqrt(75 / 3) + det([[-1, 2], [3, 1]]) - sin(pi / 4)^2";
     var encodedString = btoa(question);
     this.questionoption1 = btoa(questionoption1);
     this.questionoption2 = btoa(questionoption2);
     this.questionoption3 = btoa(questionoption3);
     this.questionoption4 = btoa(questionoption4);
     this.questiondescription = btoa(questiondescription);
    
     //console.log(this.helper.base_url+"latex.php?hex="+encodedString+"&option1="+this.questionoption1+"&option2="+this.questionoption2+"&option3="+this.questionoption3+"&option4="+this.questionoption4);
     window.open(this.helper.base_url+"latex.php?hex="+encodedString+"&option1="+this.questionoption1+"&option2="+this.questionoption2+"&option3="+this.questionoption3+"&option4="+this.questionoption4+"&option5="+this.questiondescription, "_blank");
   }
}



// WEBPACK FOOTER //
// ./src/app/chaptertest/chaptertest.component.ts